import { CellContext } from '@tanstack/react-table'
import * as React from 'react'
import { ProficiencyDots } from 'src/design-system'
import { OrgPersonalSkillsTableRow } from '../data'

export const ProficiencyCell = (
  data: CellContext<OrgPersonalSkillsTableRow, number | null>
) => {
  return <ProficiencyDots level={data.getValue()} />
}
